import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';

@Component({
    selector: 'app-header-static',
    templateUrl: './header-static.component.html',
    styleUrls: ['./header-static.component.css'],
    standalone: false
})

export class HeaderStaticComponent implements OnInit {
  accessToken = '';
  loggedInUser: Boolean = false;
  userRole:string;
  @Output() productsMenuSelectionEvent = new EventEmitter<string>();
  constructor(private router: Router, private commonService: CommonService) { }

  ngOnInit() {
    this.accessToken = localStorage.getItem('accessToken'); // Keeping this if needed elsewhere, but logic emphasizes commonService
    if (!this.commonService.isAuthenticated()) {
      this.loggedInUser = false;
    } else {
      this.loggedInUser = true;
      
      this.userRole=localStorage.getItem('userRole');
      // this.userRole=JSON.parse(this.userRole);
    }
  }

  scrollToUses(usesTabReference) {
    if (this.router.url.indexOf('/home/') === -1) {
      this.router.navigate(['/home', usesTabReference]);
    } else {
      this.productsMenuSelectionEvent.emit(usesTabReference);
    }
  }
}
